import React from 'react';

const Services = () => {
  const services = [
    {
      title: "yupiVentas Pro",
      description: "Control de inventarios y ventas para tiendas y almacenes",
      icon: "📊"
    },
    {
      title: "YupiCitas",
      description: "Gestión de citas, clientes y ventas para clinicas, salones y barberías",
      icon: "💇"
    },
    {
      title: "YupiRest",
      description: "Solución completa para restaurantes y cafeterías",
      icon: "🍽️"
    },
    {
      title: "Personalizado",
      description: "Desarrollamos software a medida para tu negocio",
      icon: "🛠️"
    }
  ];

  return (
    <section className="py-20 px-4 bg-white" id='servicios'>
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-4 text-[#03ADED]">
          Nuestras Soluciones
        </h2>
        <p className="text-xl text-center mb-12 text-gray-600 max-w-3xl mx-auto">
          Software diseñado específicamente para las necesidades de negocios peruanos
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-[#E1F5FE] p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow border border-[#B3E5FC]"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;